import { ASSET } from "../../constants";

const { ASSET_ITEM_TYPES } = ASSET;

export const getAssetFolderTree = folderTree => {
  const normalFolders = [];
  const crmFolders = [];
  if (folderTree && folderTree.length > 0) {
    folderTree.forEach(folder => {
      if (folder.opportunity_id && folder.opportunity_root) {
        crmFolders.push({ ...folder, isCRMFolder: true });
      } else {
        normalFolders.push({ ...folder, isCRMFolder: false });
      }
    });
  }
  return { normalFoldersTree: normalFolders, crmFoldersTree: crmFolders };
};

// Recursion method to get breadcrumb data from nested folders
export const generateBredcurmbData = (data, folders, parentPathArray) => {
  folders.forEach(folder => {
    if (parentPathArray.find(folderId => folderId === String(folder.id))) {
      if (folder.children && folder.children.length > 0) {
        data.push(folder);
        generateBredcurmbData(data, folder.children, parentPathArray);
      } else {
        data.push(folder);
      }
    }
  });
  return data;
};

// Method for generating the Breadcrumb data for current selected Folder
export const generateAssetBreadCrumb = (
  assetFoldersTree,
  assetFolderContent,
  assetDataToFetch,
) => {
  const data = [
    {
      id: null,
      name:
        assetDataToFetch.charAt(0).toUpperCase() +
        assetDataToFetch
          .slice(1)
          .split("-")
          .join(" "),
      children: assetFoldersTree,
    },
  ];
  if (
    assetFolderContent &&
    assetFolderContent.page &&
    assetFolderContent.page.path
  ) {
    const currentSelectedFolderParentPath = assetFolderContent.page.path;
    const currentSelectedFolderParentNameArray = currentSelectedFolderParentPath
      ? currentSelectedFolderParentPath.split("/")
      : [];

    generateBredcurmbData(
      data,
      assetFoldersTree,
      currentSelectedFolderParentNameArray,
    );
  }

  return data;
};

export const updateAssetBreadCrumb = (
  assetBreadcrumbData,
  selectedItems,
  itemEditedName,
) => {
  const cloneBreadCrumbData = [...assetBreadcrumbData];
  if (assetBreadcrumbData && assetBreadcrumbData.length > 0) {
    // Check if the folders are present inside selected items
    const isFoldersPresent = selectedItems.items.find(
      item =>
        item.type === ASSET_ITEM_TYPES.FOLDER ||
        item.folderType === ASSET_ITEM_TYPES.FOLDER,
    );
    if (isFoldersPresent) {
      const tempData = {
        ...assetBreadcrumbData[assetBreadcrumbData.length - 1],
      };
      if (tempData.children && tempData.children.length > 0) {
        if (itemEditedName) {
          tempData.children.forEach(temp => {
            if (temp.id === selectedItems.ids[0]) {
              temp.name = itemEditedName;
            }
          });
        } else {
          tempData.children = tempData.children.filter(
            temp => !selectedItems.ids.find(item => item === temp.id),
          );
        }
        cloneBreadCrumbData[assetBreadcrumbData.length - 1] = tempData;
      }
    }
  }
  return cloneBreadCrumbData;
};

// Recursion method to get the items from FolderTree by items ids and parentId
const getItmesByIdsFromFolderTree = (
  data,
  folderTree,
  selectedItems,
  checkObj,
) => {
  folderTree.forEach(folder => {
    if (folder.id === selectedItems.parentId) {
      checkObj.isMatch = true;
      const tempData = folder.children.filter(subFolder =>
        selectedItems.ids.find(item => item === subFolder.id),
      );
      data.push(...tempData);
    } else if (
      !checkObj.isMatch &&
      folder.children &&
      folder.children.length > 0
    ) {
      getItmesByIdsFromFolderTree(
        data,
        folder.children,
        selectedItems,
        checkObj,
      );
    }
  });
};

// Recursion method to update the "assetFoldersTree" in case of
// 1. add a new item
// 2. delete items
// 3. move items
// 4. rename item name
const updateFolderTree = (folders, matchId, data, type, checkObj) => {
  folders.forEach(folder => {
    if (folder.id === matchId) {
      checkObj.isMatch = true;
      let subFolders = [];
      if (type !== "RENAME") {
        subFolders = folder.children ? [...folder.children] : [];
      }
      // If it is a case of "DELETE" items
      if (type === "DELETE") {
        subFolders = subFolders.filter(
          subFolder => !data.ids.find(item => item === subFolder.id),
        );
        // folder.child_count -= subFolders.length;
      }
      // If it is a case of "CREATE" a new item
      else if (type === "CREATE") {
        subFolders.unshift(data);
      }
      // If it is a case of "MOVE" items
      else if (type === "MOVE") {
        let tempData = data;
        /**
         * When move items from one folder to other, update the following params
         * - parent_path, parent_name & parent_id
         */
        const tempParentPath = `${folder.parent_path}${folder.name}/`;
        const tempParentName = folder.name;
        const tempParenId = folder.id;
        tempData = data.map(d => ({
          ...d,
          parent_path: tempParentPath,
          parent_name: tempParentName,
          parent_id: tempParenId,
          opportunity_id: folder.opportunity_id,
          opportunity_root: folder.opportunity_root,
        }));
        subFolders.push(...tempData);
      }
      // If it is a case of "RENAME" item name
      else if (type === "RENAME") {
        folder.name = data;
      }
      if (type !== "RENAME") {
        folder.children = [...subFolders];
      }
    } else if (
      !checkObj.isMatch &&
      folder.children &&
      folder.children.length > 0
    ) {
      updateFolderTree(folder.children, matchId, data, type, checkObj);
    }
  });
};

export const updateAssetStoreAfterAddNewitem = (
  assetFoldersTree,
  newItem,
  currentParentId,
) => {
  const { normalFoldersTree, crmFoldersTree } = assetFoldersTree;
  let isCRMFolder = false;
  // Check if the selected folder is a CRM Folder
  if (crmFoldersTree && crmFoldersTree.length > 0) {
    const tempFolder = crmFoldersTree.find(
      folder => folder.id === currentParentId && folder.opportunity_id,
    );
    if (tempFolder) {
      isCRMFolder = true;
    }
  }
  // Update either "normalFoldersTree" or "crmFoldersTree"
  let tempFolderTree = [...normalFoldersTree];
  if (isCRMFolder) {
    tempFolderTree = [...crmFoldersTree];
  }
  // If the selected folder is a root folder then,
  // simply add newly create sub folder to the root level,
  // else find the selected folder and then add
  if (currentParentId === null) {
    tempFolderTree.unshift(newItem);
  } else {
    const checkObj = { isMatch: false };
    updateFolderTree(
      tempFolderTree,
      currentParentId,
      newItem,
      "CREATE",
      checkObj,
    );
  }
  return {
    crmFoldersTree: isCRMFolder ? tempFolderTree : crmFoldersTree,
    normalFoldersTree: !isCRMFolder ? tempFolderTree : normalFoldersTree,
  };
};

// Method for updating the "assetFolderContent" and "assetFoldersTree"
// after deleting the items
export const updateAssetStoreAfterDelete = (
  assetFoldersTree,
  assetFolderContent,
  selectedItems,
) => {
  // ------------ Case 1 : Delete from Right Section ------------
  // Update the "assetFolderContent" by removing the selected items
  const cloneAssetFolderContent = [...assetFolderContent.page.inodes];
  const filterFolderContent = cloneAssetFolderContent.filter(
    folder => !selectedItems.ids.find(item => item === folder.id),
  );

  // ------------ Case 2 : Delete from Left Section ------------
  let tempAssetFolderTree;
  // If selected items are folders then, delete that folders from left folder tree
  const isFoldersPresent = selectedItems.items.find(
    item =>
      item.type === ASSET_ITEM_TYPES.FOLDER ||
      item.folderType === ASSET_ITEM_TYPES.FOLDER,
  );
  if (isFoldersPresent) {
    let isCRMFolder = false;
    const { normalFoldersTree, crmFoldersTree } = assetFoldersTree;
    // Check if the selected folder is a CRM Folder
    if (crmFoldersTree && crmFoldersTree.length > 0) {
      const tempFolder = crmFoldersTree.find(
        folder => folder.id === selectedItems.parentId && folder.opportunity_id,
      );
      if (tempFolder) {
        isCRMFolder = true;
      }
    }
    // Update either "normalFoldersTree" or "crmFoldersTree"
    let tempFolderTree = [...normalFoldersTree];
    if (isCRMFolder) {
      tempFolderTree = [...crmFoldersTree];
    }

    // 1. If the selected folders are present at top level
    if (selectedItems.parentId === null) {
      tempFolderTree = tempFolderTree.filter(
        folder => !selectedItems.ids.find(item => item === folder.id),
      );
    }
    // 2. If the selected folders are present at nested level
    else {
      const checkObj = { isMatch: false };
      updateFolderTree(
        tempFolderTree,
        selectedItems.parentId,
        selectedItems,
        "DELETE",
        checkObj,
      );
    }
    tempAssetFolderTree = {
      crmFoldersTree: isCRMFolder ? tempFolderTree : crmFoldersTree,
      normalFoldersTree: !isCRMFolder ? tempFolderTree : normalFoldersTree,
    };
  }
  return {
    folderContent: filterFolderContent,
    foldersTree: tempAssetFolderTree || assetFoldersTree,
  };
};

// Method for move to asset items to other folder
/**
 * " Move to Folder" requires two actions,
 * 1. "Delete" the selected items from existing "assetFolderContent" and "assetFoldersTree",
 * 2. "Move" the selected items to destination folders
 */
export const updateAssetStoreAfterMoveToFolder = (
  assetFoldersTree,
  assetFolderContent,
  selectedItems,
  destinationFolderId,
) => {
  let cloneAssetFoldersTree;

  // Get the Selected Items from FolderTree "assetFoldersTree"
  const checkMatchObj = { isMatch: false };
  let isCurrentCRMFolder = false;
  const { normalFoldersTree, crmFoldersTree } = assetFoldersTree;
  // Check if the selected folder is a CRM Folder
  if (crmFoldersTree && crmFoldersTree.length > 0) {
    const tempFolder = crmFoldersTree.find(
      folder => folder.id === selectedItems.parentId && folder.opportunity_id,
    );
    if (tempFolder) {
      isCurrentCRMFolder = true;
    }
  }

  let getSelectedItems = [];
  if (selectedItems.parentId === null) {
    getSelectedItems = isCurrentCRMFolder
      ? crmFoldersTree
      : normalFoldersTree.filter(subFolder =>
          selectedItems.ids.find(item => item === subFolder.id),
        );
  } else {
    getItmesByIdsFromFolderTree(
      getSelectedItems,
      isCurrentCRMFolder ? crmFoldersTree : normalFoldersTree,
      selectedItems,
      checkMatchObj,
    );
  }
  /**
   * ------------------ 1. DELETE Section ------------------
   */
  // Update the "assetFolderContent" by removing the selected items
  const cloneAssetFolderContent = [...assetFolderContent.page.inodes];
  const filterFolderContent = cloneAssetFolderContent.filter(
    folder => !selectedItems.ids.find(item => item === folder.id),
  );
  // Check if the folders are present inside selected items
  const isFoldersPresent = selectedItems.items.find(
    item =>
      item.type === ASSET_ITEM_TYPES.FOLDER ||
      item.folderType === ASSET_ITEM_TYPES.FOLDER,
  );
  if (isFoldersPresent) {
    let tempFolderTree = [...normalFoldersTree];
    if (isCurrentCRMFolder) {
      tempFolderTree = [...crmFoldersTree];
    }

    // 1. If the selected folders are present at top level
    if (selectedItems.parentId === null) {
      tempFolderTree = tempFolderTree.filter(
        folder => !selectedItems.ids.find(item => item === folder.id),
      );
    }
    // 2. If the selected folders are present at nested level
    else {
      const checkObj = { isMatch: false };
      updateFolderTree(
        tempFolderTree,
        selectedItems.parentId,
        selectedItems,
        "DELETE",
        checkObj,
      );
    }

    cloneAssetFoldersTree = {
      crmFoldersTree: isCurrentCRMFolder ? tempFolderTree : crmFoldersTree,
      normalFoldersTree: !isCurrentCRMFolder
        ? tempFolderTree
        : normalFoldersTree,
    };

    /**
     * ------------------ 2. MOVE Section ------------------
     */

    let isDestCRMFolder = false;
    // Check if the selected folder is a CRM Folder
    if (crmFoldersTree && crmFoldersTree.length > 0) {
      const tempFolder = crmFoldersTree.find(
        folder => folder.id === selectedItems.parentId && folder.opportunity_id,
      );
      if (tempFolder) {
        isDestCRMFolder = true;
      }
    }

    let tempDestFolderTree = [...cloneAssetFoldersTree.normalFoldersTree];
    // Check if destination folder is a Root Folder then,
    // Simply push the selectedItems to the folderTree by updating the following params
    if (destinationFolderId === null) {
      let tempData = getSelectedItems;
      /**
       * When move items from one folder to other, update the following params
       * - parent_path, parent_name & parent_id
       */
      tempData = getSelectedItems.map(d => ({
        ...d,
        parent_path: "/",
        parent_name: "",
        parent_id: null,
        opportunity_id: undefined,
        opportunity_root: false,
      }));
      tempDestFolderTree.push(...tempData);
    } else {
      if (isDestCRMFolder) {
        tempDestFolderTree = [...cloneAssetFoldersTree.crmFoldersTree];
      }
      const checkObj = { isMatch: false };
      updateFolderTree(
        tempDestFolderTree,
        destinationFolderId,
        getSelectedItems,
        "MOVE",
        checkObj,
      );
    }

    if (destinationFolderId === null) {
      cloneAssetFoldersTree = {
        crmFoldersTree: cloneAssetFoldersTree.crmFoldersTree,
        normalFoldersTree: tempDestFolderTree,
      };
    } else {
      cloneAssetFoldersTree = {
        crmFoldersTree: isDestCRMFolder
          ? tempDestFolderTree
          : cloneAssetFoldersTree.crmFoldersTree,
        normalFoldersTree: !isDestCRMFolder
          ? tempDestFolderTree
          : cloneAssetFoldersTree.normalFoldersTree,
      };
    }
  }

  return {
    folderContent: filterFolderContent,
    foldersTree: cloneAssetFoldersTree || assetFoldersTree,
  };
};

// Method for renaming  the asset item name
export const updateAssetStoreAfterRename = (
  assetFoldersTree,
  assetFolderContent,
  selectedItem,
  data,
) => {
  // Update the "assetFolderContent" by renaming the selected item name
  const cloneAssetFolderContent = [...assetFolderContent.page.inodes];
  cloneAssetFolderContent.forEach(folder => {
    if (selectedItem.ids[0] === folder.id) {
      folder.name = data;
    }
  });

  // Update the "assetFoldersTree" by renaming the selected item name
  let isCRMFolder = false;
  const { normalFoldersTree, crmFoldersTree } = assetFoldersTree;
  // Check if the selected folder is a CRM Folder
  if (crmFoldersTree && crmFoldersTree.length > 0) {
    const tempFolder = crmFoldersTree.find(
      folder => folder.id === selectedItem.parentId && folder.opportunity_id,
    );
    if (tempFolder) {
      isCRMFolder = true;
    }
  }
  // Update either "normalFoldersTree" or "crmFoldersTree"
  let tempFolderTree = [...normalFoldersTree];
  if (isCRMFolder) {
    tempFolderTree = [...crmFoldersTree];
  }
  const checkObj = { isMatch: false };
  updateFolderTree(
    tempFolderTree,
    selectedItem.ids[0],
    data,
    "RENAME",
    checkObj,
  );
  return {
    folderContent: cloneAssetFolderContent,
    foldersTree: {
      crmFoldersTree: isCRMFolder ? tempFolderTree : crmFoldersTree,
      normalFoldersTree: !isCRMFolder ? tempFolderTree : normalFoldersTree,
    },
  };
};

export const updateFolderContentWhenStatusChange = (
  folderContent,
  newStatusList,
) => {
  const {
    page: { inodes },
  } = folderContent;
  let tempInodes = inodes;
  if (inodes && inodes.length > 0) {
    tempInodes = inodes.map(tempInode => {
      const { document_status: docStatus } = tempInode;
      if (docStatus) {
        const findChange = newStatusList.find(
          st => st.id === docStatus.id && st.isChange,
        );
        if (findChange) {
          return {
            ...tempInode,
            document_status: {
              ...tempInode.document_status,
              name: findChange.name,
              color: findChange.color,
            },
          };
        }
        return tempInode;
      }
      return tempInode;
    });
  }
  return { page: { inodes: tempInodes } };
};

export const updateFolderContentWhenTagChange = (
  folderContent,
  newTagsList,
) => {
  const {
    page: { inodes },
  } = folderContent;

  let tempInodes = inodes;
  if (inodes && inodes.length > 0) {
    tempInodes = inodes.map(tempInode => {
      const { document_tag: docTag } = tempInode;
      if (docTag) {
        const findChange = newTagsList.find(
          st => st.id === docTag.id && st.isChange,
        );
        if (findChange) {
          return {
            ...tempInode,
            document_tag: {
              ...tempInode.document_tag,
              name: findChange.name,
            },
          };
        }
        return tempInode;
      }
      return tempInode;
    });
  }
  return { page: { inodes: tempInodes } };
};

export const searchSuggestionSplitByType = inodes => {
  const files = [];
  const folders = [];
  for (let i = 0; i < inodes.length; i += 1) {
    if (
      inodes[i].type === ASSET_ITEM_TYPES.DOCUMENT ||
      inodes[i].type === ASSET_ITEM_TYPES.DOCUMENT_FORM ||
      inodes[i].type === ASSET_ITEM_TYPES.PDF
    ) {
      files.push(inodes[i]);
    } else if (inodes[i].type === ASSET_ITEM_TYPES.FOLDER) {
      folders.push(inodes[i]);
    }
  }
  return {
    files,
    folders,
  };
};

export const getAssetSearchContentIds = inodes => inodes.map(inode => inode.id);



// WEBPACK FOOTER //
// ./src/actions/AssetActions/assetMethods.js